import CardImageMarkers from "../../../../components/CockpitCards/CardImageMarkers";
import { BONES } from "../../../../constants";


export default function BonesAddOnCard() {
  

return (

    <CardImageMarkers 
    
        image={BONES}
        title="BONES HEALTH"
        subtitle="Evaluation of bone metabolism through markers of bone formation and resorption, providing insights into bone strength, turnover, and overall skeletal health"
        markersTitle=" 129,- incl. VAT"
        markers="Beta-Crosslaps (CTX), Parathyroid Hormone (PTH), Osteocalcin"
    />


)
}